// Page chunks are fingerprinted, so a deploy removes the files an already open tab
// would ask for next. Opening a lazy page then fails with a module load error.
// Reloading once fetches the new build; the timestamp stops a reload loop when the
// failure is a real outage rather than a deploy.

const RELOAD_KEY = 'chunk_reload_at'
const RETRY_AFTER_MS = 10_000

const CHUNK_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i

export function isChunkLoadError(error) {
  return CHUNK_ERROR.test(String(error?.message || error || ''))
}

// Returns true when a reload was started. `navigate` exists so tests can observe it.
export function reloadForNewDeploy(target, navigate = (url) => window.location.assign(url)) {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
    if (Date.now() - last < RETRY_AFTER_MS) return false
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    // Storage blocked: reload anyway, once per call.
  }
  navigate(target || window.location.href)
  return true
}
